class MenuCollectionPreview extends HTMLElement {
  #controller;
  #revision = 0;

  connectedCallback() {
    if (this.#controller) return;
    this.#controller = new AbortController();
    this.randomize();

    const drawer = this.closest('.menu-drawer-container');
    drawer?.addEventListener(
      'toggle',
      () => {
        if (drawer.open) this.randomize();
      },
      { signal: this.#controller.signal }
    );

    const desktopMenuItem = this.closest('.menu-list__list-item');
    desktopMenuItem?.addEventListener('pointerenter', () => this.randomize(), {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = undefined;
  }

  async randomize() {
    const slots = [...this.querySelectorAll('[data-menu-preview-slot]')];
    if (slots.length === 0) return;

    const revision = ++this.#revision;
    const groups = new Map();
    for (const slot of slots) {
      const kind = slot.dataset.menuPreviewKind || 'primary';
      if (!groups.has(kind)) groups.set(kind, []);
      groups.get(kind).push(slot);
    }

    for (const [kind, groupSlots] of groups) {
      const template = this.querySelector(`[data-menu-preview-sources="${kind}"]`);
      if (!(template instanceof HTMLTemplateElement)) continue;
      const sources = [...template.content.querySelectorAll('img')];
      if (sources.length === 0) continue;

      const shuffled = [...sources];
      for (let index = shuffled.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [shuffled[index], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[index]];
      }

      const incoming = groupSlots.map((_, index) => {
        const source = shuffled[index % shuffled.length];
        const image = new Image();
        image.loading = 'eager';
        image.decoding = 'async';
        for (const attribute of ['src', 'srcset', 'sizes', 'alt', 'width', 'height']) {
          const value = source.getAttribute(attribute);
          if (value !== null) image.setAttribute(attribute, value);
        }
        return image;
      });

      await Promise.all(incoming.map((image) => image.decode().catch(() => {})));
      if (!this.isConnected || revision !== this.#revision) return;
      groupSlots.forEach((slot, index) => slot.replaceChildren(incoming[index]));
    }
  }
}

if (!customElements.get('menu-collection-preview')) {
  customElements.define('menu-collection-preview', MenuCollectionPreview);
}
